{
  "entitySuggestion": {
    "duplicates": {
      "heading": {
        "system": "Möglicherweise existiert dieses System bereits",
        "orgFunction": "Möglicherweise existiert diese Funktion bereits"
      },
      "useThisInstead": {
        "system": "Dieses System verwenden",
        "orgFunction": "Diese Funktion verwenden"
      },
      "reasons": {
        "same_category": "Gleiche Kategorie",
        "same_department": "Gleiche Abteilung"
      },
      "linkError": "Vorschlag konnte nicht verknüpft werden. Bitte erneut versuchen.",
      "checking": "Suche nach Duplikaten…"
    },
    "kind": {
      "system": "System",
      "orgFunction": "Funktion"
    },
    "system": {
      "dialog": {
        "title": "System vorschlagen",
        "description": "Ein Administrator prüft deinen Vorschlag und nimmt das System auf.",
        "name": "Systemname",
        "description_field": "Beschreibung",
        "category": "Kategorie",
        "categoryHint": "Um was für eine Art von System handelt es sich am ehesten? z.B. CRM / ERP / HCM",
        "url": "Link zur Website des Anbieters",
        "submit": "Vorschlagen"
      },
      "card": {
        "pendingBadge": "Vorgeschlagen"
      }
    },
    "orgFunction": {
      "dialog": {
        "team": {
          "title": "Team vorschlagen",
          "description": "Ein Administrator prüft deinen Vorschlag und legt das Team an.",
          "name": "Name des Teams"
        },
        "role": {
          "title": "Funktion vorschlagen",
          "description": "Ein Administrator prüft deinen Vorschlag und legt die Funktion an.",
          "name": "Name der Funktion / der Rolle / des Teams"
        },
        "description_field": "Beschreibung",
        "department": "Abteilung",
        "departmentHint": "In welcher Abteilung ist die Funktion am besten verortet?",
        "email": "E-Mail",
        "submit": "Vorschlagen"
      },
      "card": {
        "pendingBadge": "Vorgeschlagen"
      }
    },
    "review": {
      "titleSystem": "Systemvorschlag prüfen",
      "titleTeamSuggestion": "Teamvorschlag prüfen",
      "titleFunctionSuggestion": "Funktionsvorschlag prüfen",
      "descriptionSystem": "{{name}} als neues System in den Katalog aufnehmen oder mit einem bestehenden System zusammenführen.",
      "descriptionTeamSuggestion": "{{name}} als neues Team in den Katalog aufnehmen oder mit einem bestehenden Team zusammenführen.",
      "descriptionFunctionSuggestion": "{{name}} als neue Funktion in den Katalog aufnehmen oder mit einer bestehenden Funktion zusammenführen.",
      "createAsNew": {
        "system": "System erstellen",
        "team": "Team erstellen",
        "function": "Funktion erstellen"
      },
      "titleApproveSystem": "Genehmigen & System erstellen",
      "titleApproveTeam": "Genehmigen & Team erstellen",
      "titleApproveFunction": "Genehmigen & Funktion erstellen",
      "descriptionApproveSystem": "{{name}} als neues System erstellen und den Vorschlag genehmigen. Aufnahmen, die darauf verwiesen, werden mit dem neuen System verknüpft.",
      "descriptionApproveTeam": "{{name}} als neues Team erstellen und den Vorschlag genehmigen. Aufnahmen, die darauf verwiesen, werden mit dem neuen Team verknüpft.",
      "descriptionApproveFunction": "{{name}} als neue Funktion erstellen und den Vorschlag genehmigen. Aufnahmen, die darauf verwiesen, werden mit der neuen Funktion verknüpft.",
      "approveAndCreate": "Genehmigen & erstellen",
      "proposedDetails": {
        "headingSystem": "Neues System",
        "headingTeam": "Neue Funktion",
        "name": "Name",
        "kind": "Art",
        "category": "Kategorie",
        "url": "Link zum System",
        "description": "Beschreibung",
        "department": "Abteilung",
        "email": "E-Mail"
      },
      "mergeWithExistingSection": {
        "system": "Stattdessen mit bestehendem System zusammenführen",
        "orgFunction": "Stattdessen mit bestehender Funktion zusammenführen"
      },
      "mergeSelectPlaceholder": {
        "system": "Bestehendes System auswählen…",
        "orgFunction": "Bestehende Funktion auswählen…"
      },
      "confirmMerge": {
        "title": {
          "system": "Mit bestehendem System zusammenführen?",
          "orgFunction": "Mit bestehender Funktion zusammenführen?"
        },
        "description": {
          "system": "„{{suggestionName}}\" wird mit „{{targetName}}\" zusammengeführt. Die Aufnahme verweist anschließend auf das bestehende System. Diese Aktion kann nicht rückgängig gemacht werden.",
          "orgFunction": "„{{suggestionName}}\" wird mit „{{targetName}}\" zusammengeführt. Die Aufnahme verweist anschließend auf die bestehende Funktion. Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "confirm": "Zusammenführen"
      },
      "reject": "Ablehnen",
      "approved": "Vorschlag genehmigt",
      "rejected": "Vorschlag abgelehnt",
      "merged": "Vorschlag zusammengeführt",
      "sourceRecording": "Vorgeschlagen in",
      "submittedBy": "Eingereicht von",
      "submittedAt": "Eingereicht am",
      "confirmReject": {
        "title": "Vorschlag ablehnen?",
        "description": "Der Vorschlag wird abgelehnt und nicht zur Wissensbasis hinzugefügt. Bitte gib einen Grund an."
      },
      "fields": {
        "rejectionReason": "Grund für die Ablehnung"
      },
      "placeholders": {
        "rejectionReason": "Bitte kurz erläutern, warum der Vorschlag abgelehnt wird"
      }
    }
  }
}
